import { useCreateDailyCheckinMutation } from "store/dailycheckin";
import type { ErrorProps } from "modules/types";
import Notification from "components/notification";
import GLOBAL from "modules/global";
import DailyCheckinForm from "pages/dailycheckin/form/form";


export default function Create({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void
}
) {
  const [create, createResult] = useCreateDailyCheckinMutation();

  function handleCreate(formData: FormData) {
    create(formData);
  }

  if (!open) return null

  return (
    <>
      <DailyCheckinForm onSubmit={handleCreate} open={open} onClose={onClose} loading={createResult.isLoading} />

      <Notification
        open={!createResult.isLoading && !createResult.isUninitialized}
        onClose={() => (createResult.isError ? createResult.reset() : location.reload())}
        isError={Boolean(createResult.error) && createResult.isError}
        message={GLOBAL.returnExceptionMessage(createResult.isError, createResult.error as ErrorProps)}
      />
    </>
  )
}

